module.exports = __webpack_public_path__ + "static/media/tareq-ajalyakin-QGlntT8_57o-unsplash.3b76d33a.jpg";